var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTenEuroLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 106,
    viewBox: "0 0 113 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1257_12141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.8117 44.4588C98.0894 44.4588 98.9424 45.776 98.4198 46.9419L97.3335 49.3652C97.0494 49.9989 96.4198 50.4066 95.7254 50.4066H64.5532C63.32 50.4066 62.4681 49.1725 62.9055 48.0194L63.8247 45.5961C64.0844 44.9115 64.7402 44.4588 65.4724 44.4588H96.8117ZM91.4515 55.5341C92.7615 55.5341 93.6136 56.9127 93.0277 58.0844L91.7135 60.7129C91.415 61.3099 90.8048 61.687 90.1373 61.687H64.5231C63.2982 61.687 62.4469 60.4682 62.8686 59.3181L63.8324 56.6897C64.0869 55.9955 64.7476 55.5341 65.4869 55.5341H91.4515ZM105.379 29.4918C106.106 29.9403 106.343 30.8693 105.979 31.6414L102.046 39.9686C101.665 40.7753 100.749 41.1453 99.9671 40.7151C99.8371 40.6435 99.7009 40.5668 99.5585 40.485C98.7723 40.0065 97.7896 39.5621 96.6103 39.1519C95.448 38.7246 94.0978 38.511 92.5596 38.511C90.5428 38.511 88.8422 38.981 87.4578 39.921C86.0734 40.844 85.0222 42.3736 84.3044 44.5101C83.5865 46.6294 83.2276 49.4837 83.2276 53.0729C83.2276 56.6963 83.5865 59.5591 84.3044 61.6614C85.0222 63.7465 86.0734 65.2335 87.4578 66.1223C88.8422 66.9939 90.5428 67.4298 92.5596 67.4298C94.0636 67.4298 95.3882 67.2332 96.5333 66.8401C97.6956 66.447 98.6612 66.0197 99.4303 65.5582C99.4718 65.5339 99.5126 65.51 99.5529 65.4864C100.427 64.974 101.538 65.3309 101.971 66.2474L105.793 74.3396C106.149 75.0936 105.932 76.0014 105.233 76.4559C103.646 77.4877 101.916 78.2904 100.046 78.864C97.7212 79.5818 95.2258 79.9407 92.5596 79.9407C87.9107 79.9407 83.7916 78.8981 80.2024 76.813C76.6303 74.7278 73.8273 71.6855 71.7934 67.6861C69.7766 63.6867 68.7682 58.8156 68.7682 53.0729C68.7682 47.3302 69.7766 42.442 71.7934 38.4084C73.8273 34.3748 76.6303 31.2984 80.2024 29.179C83.7916 27.0597 87.9107 26 92.5596 26C95.3284 26 97.875 26.376 100.199 27.128C102.044 27.7114 103.771 28.4993 105.379 29.4918Z",
    fill: "url(#paint0_linear_1257_12141)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1257_12141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1088 80.4223C48.3848 80.4053 44.3042 79.3132 40.8671 77.146C37.43 74.9787 34.7801 71.8548 32.9176 67.7743C31.0552 63.6937 30.1324 58.8004 30.1493 53.0944C30.1662 47.3715 31.0975 42.5121 32.943 38.5162C34.8055 34.5203 37.4469 31.481 40.8671 29.3984C44.3042 27.3158 48.3848 26.2745 53.1088 26.2745C57.8327 26.2745 61.9133 27.3243 65.3504 29.4238C68.7876 31.5064 71.4374 34.5457 73.2999 38.5416C75.1624 42.5375 76.0851 47.3884 76.0682 53.0944C76.0682 58.8343 75.137 63.7445 73.2745 67.825C71.412 71.9056 68.7622 75.0295 65.325 77.1968C61.9048 79.3471 57.8327 80.4223 53.1088 80.4223ZM53.1088 68.9425C55.5469 68.9425 57.5449 67.6727 59.1026 65.1329C60.6772 62.5762 61.4561 58.5634 61.4392 53.0944C61.4392 49.5218 61.0836 46.6011 60.3725 44.3322C59.6613 42.0634 58.6793 40.3871 57.4264 39.3035C56.1734 38.203 54.7342 37.6527 53.1088 37.6527C50.6706 37.6527 48.6811 38.8887 47.1403 41.3607C45.5995 43.8328 44.8122 47.744 44.7783 53.0944C44.7614 56.7347 45.1085 59.7317 45.8196 62.0852C46.5308 64.4218 47.5128 66.1488 48.7658 67.2663C50.0356 68.3838 51.4833 68.9425 53.1088 68.9425Z",
    fill: "url(#paint1_linear_1257_12141)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1257_12141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 79.1473C35 79.8543 34.4269 80.4273 33.72 80.4273H21.3243C20.6174 80.4273 20.0443 79.8543 20.0443 79.1473V51.6273C20.0443 49.6202 20.0689 47.7112 20.118 45.9001C20.1514 44.6668 18.4993 43.9907 17.5974 44.8326C17.3521 45.0616 17.0986 45.2924 16.8368 45.525L11.6386 49.8052C11.091 50.256 10.2812 50.1756 9.83293 49.6259L3.81012 42.2395C3.3629 41.691 3.44562 40.8837 3.99478 40.4373L21.3698 26.3141C21.598 26.1286 21.8831 26.0273 22.1772 26.0273H33.72C34.4269 26.0273 35 26.6004 35 27.3073V79.1473Z",
    fill: "url(#paint2_linear_1257_12141)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1257_12141",
    x: 60.1144,
    y: 21.5944,
    width: 52.2019,
    height: 62.7526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.76225
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.20281
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1257_12141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1257_12141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1257_12141",
    x: 27.5063,
    y: 21.9109,
    width: 54.6976,
    height: 62.8754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.74578
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.18222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1257_12141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1257_12141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1257_12141",
    x: 0.643438,
    y: 21.2273,
    width: 41.0766,
    height: 64.0004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.92
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1257_12141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1257_12141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1257_12141",
    x1: 133.374,
    y1: 5.96522,
    x2: 101.194,
    y2: 54.7326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#5555FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1257_12141",
    x1: 111.8,
    y1: -39.3708,
    x2: 43.2809,
    y2: 23.4087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#5555FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1257_12141",
    x1: 54.2,
    y1: 5.82198,
    x2: 19,
    y2: 43.7648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#5555FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenEuroLogo);
export default __webpack_public_path__ + "static/media/TenEuroLogo.2768138637b6607183311f9927dd3838.svg";
export { ForwardRef as ReactComponent };